import { render, staticRenderFns } from "./AddUpdateWiki.vue?vue&type=template&id=0d2cf435&"
import script from "./AddUpdateWiki.vue?vue&type=script&lang=js&"
export * from "./AddUpdateWiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports